import UserPageReducer from './UserPageReducer';

export default from './UserPageContainer';

export const UserPageReducers = {
  UserPageReducer,
};
